import * as Sentry from '@sentry/react';
import { queryOptions } from '@tanstack/react-query';

import { UserSession } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const AUTH_SESSION_QUERY_KEY = 'auth-session';

export const getSessionQueryOptions = () =>
  queryOptions<UserSession>({
    queryKey: [AUTH_SESSION_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.auth.session();
      const { userId, name, nickname, email } = data;
      Sentry.setUser({
        id: userId,
        name,
        nickname,
        email,
      });
      return data;
    },
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
